/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SignupStatus = {
    NotStarted: 'NOT_STARTED',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED'
} as const;
export type SignupStatus = typeof SignupStatus[keyof typeof SignupStatus];


export function instanceOfSignupStatus(value: any): boolean {
    for (const key in SignupStatus) {
        if (Object.prototype.hasOwnProperty.call(SignupStatus, key)) {
            // @ts-ignore
            if (SignupStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SignupStatusFromJSON(json: any): SignupStatus {
    return SignupStatusFromJSONTyped(json, false);
}

export function SignupStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignupStatus {
    return json as SignupStatus;
}

export function SignupStatusToJSON(value?: SignupStatus | null): any {
    return value as any;
}

